import { Typography, Button } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import { BookingSettingsCounter } from 'components/views/pages/Checkout/CheckoutStep1/components/BookingSettingsCounter';
import { CheckoutParamEnum } from 'components/views/pages/Checkout/types';
import { useAppParam } from 'hooks/useAppParam';
import { useState } from 'react';

interface Props {
  pets: string | undefined;
  isOpen: boolean;
  close: () => void;
}

export const BookingSettingsPetsDialog = ({ pets, isOpen, close }: Props) => {
  const { setParam } = useAppParam(CheckoutParamEnum.pets);
  const [p, setP] = useState(pets ? Number(pets) : 0);

  const onSubmit = () => {
    setParam(p);
    close();
  };

  return (
    <ConfirmationDialog
      dialogTitle={'Pets'}
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      maxWidth="xs"
    >
      <Typography>
        If you are bringing <strong>more than 2 pets</strong> on your trip, please notify the host before confirming
        your reservation.
      </Typography>
      <AppDivider marginVertical="24px" />
      <BookingSettingsCounter title="Pets" subtitle="" value={p} setValue={setP} />

      <Button variant="contained" color="secondary" fullWidth size="large" onClick={onSubmit}>
        Continue
      </Button>
    </ConfirmationDialog>
  );
};
